const SLIDE_SPEED = 200;
export { SLIDE_SPEED };
